import React from "react";
import { observer } from "mobx-react";
import useDayAndTime from "@hooks/useDayAndTimeFromEventStartTime";
import { Event } from "@gp/models";

export const StartTime = observer(function StartTime(props: {
	event: Event;
	className: string;
}) {
	const { event, className } = props;

	const { day, time } = useDayAndTime(event.startTime, true);

	return (
		<span className={className}>
			<span className="offer__day__date u-mar--right--nano">{day}</span>
			<strong className="offer__day__time">{time}</strong>
		</span>
	);
});
